import React, { memo, useContext } from 'react'
import { CSS } from '@dnd-kit/utilities'
import { useDraggable } from '@dnd-kit/core'
import Droppable from './Droppable'
import classNames from 'classnames'
import CloseIcon from '@mui/icons-material/Close'
import { Button, Typography } from '@mui/material'
import {DraggingAssignContext} from "src/components/pages/sales/business-rule/logic/FormulaComponent";

const OperatorItem = memo(({ item, highlight = {}, onClickRemove, ...props }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: item.id,
    disabled: props.onlyView,
  })
  const { isSmall } = useContext(DraggingAssignContext);
  const getStyle = () => {
    if (transform) {
      transform.scaleX = 1
      transform.scaleY = 1
    }

    return {
      transform: CSS.Transform.toString(transform),
      backgroundColor: item.color,
    }
  }

  const getChildren = (position) => {
    const child = item.children?.find((elem) => elem.position === position)
    return child ? [child] : []
  }

  const getClassNames = (position) => {
    return classNames('white_space', {
      highlight: highlight.valid === `form_${item.id}_${position}`,
      highlight_not_valid: highlight.not_valid === `form_${item.id}_${position}`,
      small: isSmall
    })
  }

  return (
    <>
      <div
        ref={setNodeRef}
        className={classNames('operator_structure', {
          dragging: isDragging,
          embedded: item.parentId,
          small: isSmall
        })}
        key={item.id}
        style={getStyle()}
        {...listeners}
        {...attributes}
      >
        <div className={getClassNames(1)}>
          {!item.isOperator && (
            <Droppable
              id={`form_${item.id}_${1}`}
              items={getChildren(1)}
              highlight={highlight}
              onClickRemove={onClickRemove}
              embedded
              {...props}
            />
          )}
        </div>
        <span
          style={{
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0px 6px',
          }}
        >
          {item.icon}
        </span>
        <div>
          {item?.id && !item.isOperator && item?.detail?.text && (
            <div style={{ position: 'absolute' }}>
              <Typography
                style={{
                  fontSize: '10px',
                  position: 'relative',
                  top: '-7px',
                  color: 'white',
                  fontWeight: 'bold',
                }}
              >
                {item?.detail?.text}
              </Typography>
            </div>
          )}
          <div
            className={getClassNames(2)}
            style={{
              backgroundColor:
                item?.detail?.background && !item.isOperator ? item?.detail?.background : 'white',
            }}
          >
            {!item.isOperator && (
              <Droppable
                id={`form_${item.id}_${2}`}
                items={getChildren(2)}
                highlight={highlight}
                onClickRemove={onClickRemove}
                embedded
                {...props}
              />
            )}
          </div>
        </div>
        {!item.isOperator && !props.onlyView && (
          <div>
            <Button
              className={classNames('close_icon', {
                small: isSmall
              })}
              onClick={() => onClickRemove(item)}
              onMouseDown={(e) => e.stopPropagation()}
            >
              <CloseIcon fontSize='13' />
            </Button>
          </div>
        )}
      </div>
    </>
  )
})

export default OperatorItem
